import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { AppHeader } from './components/AppHeader.tsx'
import { InstallHint } from './components/InstallHint.tsx'
import { currentFestivalDay } from './domain/time.ts'
import { DAYS } from './program.ts'
import { StoreProvider } from './store/StoreProvider.tsx'
import { AuthProvider } from './store/AuthProvider.tsx'
import type { LocalAnnotationStore } from './store/annotations.ts'
import type { LocalFriendStore } from './store/friends.ts'
import { ConcertDetail } from './routes/ConcertDetail.tsx'
import { DayView } from './routes/DayView.tsx'
import { FestivalMap } from './routes/FestivalMap.tsx'
import { Friends } from './routes/Friends.tsx'
import { NotFound } from './routes/NotFound.tsx'
import { t } from './i18n.ts'

/** The day the app opens on: today if the festival is running, otherwise day one. */
export function landingDay(now = new Date()): string {
  return currentFestivalDay(DAYS, now) ?? DAYS[0] ?? ''
}

export function App({
  store,
  friends,
}: { store?: LocalAnnotationStore; friends?: LocalFriendStore } = {}) {
  return (
    <StoreProvider store={store} friends={friends}>
      <Router>
        <AuthProvider>
          <a className="skip-link" href="#innhold">
            {t.nav.skipToContent}
          </a>
          <AppHeader />
          <InstallHint />
          <main className="app-main" id="innhold">
            <Routes>
              <Route path="/" element={<Navigate to={`/dag/${landingDay()}`} replace />} />
              <Route path="/dag/:day" element={<DayView />} />
              <Route path="/konsert/:id" element={<ConcertDetail />} />
              <Route path="/venner" element={<Friends />} />
              <Route path="/kart" element={<FestivalMap />} />
              {/* «Delt med meg» was a page with a header action, so it has bookmarks
                  and home-screen shortcuts behind it. The friends page absorbed what
                  it showed (A1), so the old address lands there rather than on
                  not-found. Emailed and push links are unaffected either way: both
                  deep-link to /konsert/:id?delt=, never here. */}
              <Route path="/delt" element={<Navigate to="/venner" replace />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
        </AuthProvider>
      </Router>
    </StoreProvider>
  )
}
